import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { ProjectsContainer, ProjectsHero, ProjectsGrid, ProjectCard, ProjectImage, ProjectOverlay, ProjectContent, HeroContent, portfolioData } from './estilosProjects';


function Projects() {
  // Mostramos siempre todos los proyectos
  const filteredProjects = portfolioData;

  // Función para obtener la captura de pantalla
  const getScreenshotUrl = (projectUrl) => {
    if (!projectUrl || projectUrl.includes('localhost')) {
      const hostname = projectUrl ? new URL(projectUrl).hostname : 'URL Inválida';
      return `https://via.placeholder.com/1280x930.png?text=Vista+Previa+No+Disponible+Para+${hostname}`;
    }
    return `https://s.wordpress.com/mshots/v1/${encodeURIComponent(projectUrl)}?w=1280&h=930`;
  };

  return (
    <ProjectsContainer>
      <Helmet>
        <title>Proyectos digitales que marcan diferencia | Juanfra Hernández</title>
        <meta name="description" content="Descubre una selección de proyectos diseñados con precisión y estrategia. Cada trabajo es una muestra real de soluciones digitales efectivas y bien pensadas." />
        <link rel="canonical" href="https://juanfrahernandez.es/proyectos" />
      </Helmet>

      <ProjectsHero>
        <video autoPlay muted loop playsInline poster="https://www.pexels.com/es-es/foto/dos-imac-con-teclado-y-telefonos-en-el-escritorio-326503/">
          <source src="https://videos.pexels.com/video-files/4624334/4624334-uhd_2560_1440_25fps.mp4" type="video/mp4" />
        </video>
        <HeroContent
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>Nuestros Proyectos</h1>
          <p>Transformando ideas en experiencias digitales excepcionales</p>
        </HeroContent>
      </ProjectsHero>

      <ProjectsGrid>
        <AnimatePresence mode="wait">
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.id}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              onClick={() => window.open(project.url, '_blank')}
              style={{ cursor: 'pointer' }}
            >
              <ProjectImage 
                src={getScreenshotUrl(project.url)} 
                alt={`Vista previa visual de ${project.title}`} 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = project.image || `https://via.placeholder.com/800x600.png?text=Error+Al+Cargar+Vista+Previa+Para+${project.title}`; 
                }}
              />
              <ProjectOverlay>
                <ProjectContent>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  
                  <motion.div 
                    style={{ 
                      marginTop: '1rem', 
                      fontSize: '0.9rem', 
                      opacity: 0.8,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    whileHover={{ opacity: 1 }}
                  >
                    <span style={{ marginRight: '5px' }}>Visitar sitio</span>
                    <span>→</span>
                  </motion.div>
                </ProjectContent>
              </ProjectOverlay>
            </ProjectCard>
          ))}
        </AnimatePresence>
      </ProjectsGrid>
    </ProjectsContainer>
  );
}

export default Projects;